// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3NBTC","label":"Section_label__207nu","contentWrap":"Section_contentWrap__3_Cxx","footer":"Section_footer__3O-l9","footerInner":"Section_footerInner__8XUcr"};